export const ICATU_CONTACTS = {
  sac: '0800 286 0109',
  ouvidoria: '0800 286 0047',
  crc: '0800 285 2712',
} as const;
